import React, { useMemo, useState } from 'react';
import { Button, Col, Input, Radio, Row, message } from 'antd';
import { useI18n } from 'hooks/useI18n';
import { SMSPageShell, SMSPanel, SMS_PAGE_CREDIT_COUNT } from '../shared';

const OPTIONS = [
	{
		labelKey: 'sms.bulk.options.active_member',
		descriptionKey: 'sms.bulk.option_descriptions.active_member',
		value: 'activeMember',
		count: 77,
	},
	{
		labelKey: 'sms.bulk.options.inactive_member',
		descriptionKey: 'sms.bulk.option_descriptions.inactive_member',
		value: 'inactiveMember',
		count: 64,
	},
	{
		labelKey: 'sms.bulk.options.pending_payment',
		descriptionKey: 'sms.bulk.option_descriptions.pending_payment',
		value: 'pendingPayment',
		count: 48,
	},
	{
		labelKey: 'sms.bulk.options.paid_member',
		descriptionKey: 'sms.bulk.option_descriptions.paid_member',
		value: 'paidMember',
		count: 92,
	},
	{
		labelKey: 'sms.bulk.options.expired_member',
		descriptionKey: 'sms.bulk.option_descriptions.expired_member',
		value: 'expiredMember',
		count: 33,
	},
];

const SendBulkSMS = () => {
	const { t } = useI18n();
	const [selectedAudience, setSelectedAudience] = useState(OPTIONS[0].value);
	const [messageText, setMessageText] = useState('');

	const selectedOption = useMemo(() => OPTIONS.find((option) => option.value === selectedAudience) || OPTIONS[0], [selectedAudience]);

	const onChange = (e) => {
		setSelectedAudience(e.target.value);
	};

	const handleSend = () => {
		message.success(t('sms.common.send_demo'));
	};

	return (
		<SMSPageShell
			eyebrow={t('navigation.sms')}
			title={t('sms.bulk.title')}
			subtitle={t('sms.bulk.subtitle')}
			creditLabel={t('sms.common.available_credits')}
			creditCount={SMS_PAGE_CREDIT_COUNT}
			meta={[
				{ label: t('sms.bulk.metrics.audience'), value: t(selectedOption.labelKey), helper: t(selectedOption.descriptionKey) },
				{ label: t('sms.common.recipients'), value: selectedOption.count, helper: t('sms.bulk.metrics.recipients_helper') },
				{ label: t('sms.common.message_length'), value: `${messageText.length}/160`, helper: t('sms.bulk.metrics.message_helper') },
			]}
		>
			<Row gutter={[16, 16]}>
				<Col xs={24} xl={12}>
					<SMSPanel title={t('sms.bulk.audience_title')} subtitle={t('sms.bulk.audience_subtitle')}>
						<Radio.Group onChange={onChange} value={selectedAudience} style={{ width: '100%' }}>
							<div className="sms-option-grid">
								{OPTIONS.map((option) => {
									const isActive = option.value === selectedAudience;
									return (
										<label key={option.value} className={`sms-option-card ${isActive ? 'is-active' : ''}`.trim()}>
											<Radio value={option.value}>
												<div className="sms-option-card__row">
													<div>
														<span className="sms-option-card__title">{t(option.labelKey)}</span>
														<p className="sms-option-card__description">{t(option.descriptionKey)}</p>
													</div>
													<span className="sms-option-card__count">{option.count}</span>
												</div>
											</Radio>
										</label>
									);
								})}
							</div>
						</Radio.Group>
					</SMSPanel>
				</Col>
				<Col xs={24} xl={12}>
					<SMSPanel
						title={t('sms.common.compose_title')}
						subtitle={t('sms.bulk.compose_subtitle')}
						footer={
							<div className="sms-message-toolbar" style={{ width: '100%' }}>
								<span className="sms-stat-card__helper">{t('sms.bulk.delivery_note', { count: selectedOption.count })}</span>
								<Button className="sms-send-button" type="primary" onClick={handleSend} disabled={!messageText.trim()}>
									{t('sms.bulk.send_button')}
								</Button>
							</div>
						}
					>
						<div className="sms-composer">
							<Input.TextArea placeholder={t('sms.bulk.message_placeholder')} rows={7} value={messageText} onChange={(event) => setMessageText(event.target.value)} />
						</div>
						<div className="sms-preview sms-preview--message">
							<span className="sms-preview__eyebrow">{t('sms.common.preview')}</span>
							<div className="sms-preview__bubble">{messageText || t('sms.bulk.preview_placeholder')}</div>
							<div className="sms-preview__meta">
								<span className="sms-recipient-pill"><strong>{t('sms.bulk.metrics.audience')}</strong>{t(selectedOption.labelKey)}</span>
							</div>
						</div>
					</SMSPanel>
				</Col>
			</Row>
		</SMSPageShell>
	);
};

export default SendBulkSMS;
